import { Checkbox, Form, Input, InputNumber, Radio, Switch } from 'antd';
import { defaultConfiguration } from '../../../constants/constants';
import { useStore } from '../../../store/store';
import { ColorPaletteButton } from '../../common/ColorPaletteButton';
import FontPicker from '../../common/FontPicker';

const selector = ({ configuration, setConfiguration }) => ({
  configuration,
  setConfiguration,
});

export const TabsWatermark = () => {
  const { configuration, setConfiguration } = useStore(selector);
  // Réglages par défaut tant que la configuration n'en a pas.
  const watermark = configuration.watermark ?? defaultConfiguration.watermark;
  const disabled = !watermark.enabled;

  const update = (values) => {
    setConfiguration({ watermark: { ...watermark, ...values } });
  };

  return (
    <>
      {/* Pas de `name` : champs pilotés par le store (cf. pageTab). */}
      <Form.Item label='Filigrane'>
        <Switch
          checked={watermark.enabled}
          // Activé avec un texte vide, aucun filigrane ne s'affichait alors que
          // « BROUILLON » apparaissait (en exemple) dans le champ.
          onChange={(enabled) =>
            update(enabled && !watermark.text?.trim() ? { enabled, text: 'BROUILLON' } : { enabled })
          }
        />
      </Form.Item>
      <Form.Item label='Texte'>
        <Input
          disabled={disabled}
          placeholder='BROUILLON'
          maxLength={60}
          style={{ width: 300 }}
          value={watermark.text}
          onChange={(e) => update({ text: e.target.value })}
        />
      </Form.Item>
      <Form.Item label='Police'>
        <FontPicker
          allowClear
          disabled={disabled}
          placeholder='Helvetica (par défaut)'
          forcedValue={watermark.fontFamily || undefined}
          onChange={(fontFamily) => update({ fontFamily })}
        />
      </Form.Item>
      <Form.Item label='Taille de police'>
        <InputNumber
          disabled={disabled}
          min={10}
          max={300}
          value={watermark.size}
          onChange={(size) => size && update({ size })}
        />
      </Form.Item>
      <Form.Item label='Gras'>
        <Checkbox
          disabled={disabled}
          checked={watermark.fontWeight === 'bold'}
          onChange={(e) =>
            update({ fontWeight: e.target.checked ? 'bold' : '' })
          }
        />
      </Form.Item>
      <Form.Item label='Couleur'>
        {/* Pas de transparent : un filigrane invisible ne se remarquerait
            qu'une fois le PDF sorti. */}
        <ColorPaletteButton
          title='Couleur du filigrane'
          disabled={disabled}
          disableTransparent
          value={watermark.color}
          colors={configuration.colors}
          onChange={(label) =>
            update({
              color: configuration.colors.find(
                (color) => color.label === label
              ),
            })
          }
        />
      </Form.Item>
      <Form.Item label='Opacité'>
        <InputNumber
          disabled={disabled}
          min={5}
          max={100}
          addonAfter='%'
          style={{ width: 150 }}
          value={Math.round(watermark.opacity * 100)}
          onChange={(percent) => percent && update({ opacity: percent / 100 })}
        />
      </Form.Item>
      <Form.Item label='Pages'>
        <Radio.Group
          disabled={disabled}
          value={watermark.pages}
          onChange={(e) => update({ pages: e.target.value })}
          options={[
            { value: 'all', label: 'Toutes les pages' },
            {
              value: 'content',
              label:
                'Sauf les pages pleine page (couverture, séparateurs, PDF importés en pleine page)',
            },
          ]}
        />
      </Form.Item>
      <Form.Item label='Affichage'>
        <Radio.Group
          disabled={disabled}
          value={watermark.display ?? 'always'}
          onChange={(e) => update({ display: e.target.value })}
          options={[
            { value: 'always', label: 'Toujours' },
            {
              value: 'missingValues',
              label: 'Seulement si le formulaire a des valeurs manquantes',
            },
          ]}
        />
      </Form.Item>
      <Form.Item label='Archivage'>
        <Checkbox
          disabled={disabled}
          checked={watermark.hideOnArchive}
          onChange={(e) => update({ hideOnArchive: e.target.checked })}
        >
          Pas de filigrane sur le PDF archivé
        </Checkbox>
      </Form.Item>
    </>
  );
};
